import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { UserIdleService } from "angular-user-idle";
import { UserAccount } from "src/app/shared/models/user-account";
import { DialogConfirmComponent } from "../dialog-confirm/dialog-confirm.component";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class AutologoutService {
  myTimeout: NodeJS.Timeout;
  currentUser: UserAccount;
  constructor(
    private userIdle: UserIdleService,
    private router: Router,
    private authService: AuthService,
    public dialog: MatDialog
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem("CurrentUser"));
  }

  StartTimer() {
    //Start watching for user inactivity.
    this.userIdle.startWatching();

    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe((resp) => {});
  }

  OnTimerOut() {
    this.userIdle.onTimeout().subscribe(() => {
      if (
        this.router.url != "/signin" &&
        this.router.url != "/waiting-room" &&
        this.router.url != "/authentication/signin"
      ) {
        const dialogRef = this.dialog.open(DialogConfirmComponent, {
          data: {},
          maxWidth: "750px",
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe({
          next: (resp: any) => {
            if (resp == 1) {
              this.Logout();
            } else {
              this.Reset();
            }
          },
          error: () => {},
        });
        this.myTimeout = setTimeout(() => {
          this.authService.Logout(this.currentUser);
        }, 10000);
      }
    });
  }
  Logout() {
    clearTimeout(this.myTimeout);
    this.ResetTimer();
    this.authService.Logout(this.currentUser);
  }
  Reset() {
    clearTimeout(this.myTimeout);
    this.ResetTimer();
    this.dialog.closeAll();
  }
  ResetTimer() {
    this.userIdle.resetTimer();
  }
}
